import React from "react";

export default function BannerCard({
    banner,
    onClick

}) {
    return (
        <button
            className="banner-card"
            onClick={onClick}
        >
            <img
                src={banner.image}
                alt={banner.title}
            />
        </button>
    );

}